import React from "react";
import Heading from "../../common/heading/Heading";
import "../student/Student.css";
import { homeAbout1 } from "../../../dummydata";
import { getImageUrl } from "../../../config/s3Config";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Student = () => {
  const coverImages = [
    getImageUrl("/images/Cover Design/01.jpg"),
    getImageUrl("/images/Cover Design/02.jpg"),
    getImageUrl("/images/Cover Design/03.jpg"),
    getImageUrl("/images/Cover Design/04.jpg"),
    getImageUrl("/images/Cover Design/05.jpg"),
    getImageUrl("/images/WEB Post Mobile/web 360x640 Graduation 07.png"),
    getImageUrl("/images/WEB Post Mobile/web 360x640 Graduation 08.png"),
    getImageUrl("/images/WEB Post Mobile/web 360x640 workshop9.png"),
    getImageUrl("/images/WEB Post Mobile/web 360x640 workshop6.png"),
    getImageUrl("/images/WEB Post Mobile/web 360x640 workshop7.png"),

  ];

  const sliderSettings = {
    
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    pauseOnHover: true,
    adaptiveHeight: true,
  };

  return (
    <section className="student-section">
      <div className="container student-container">
        {/* Left: Slider */}
        <div className="student-slider">
          <Slider {...sliderSettings}>
            {coverImages.map((src) => (
              <div key={src} className="slide-item">
                <img
                  src={src}
                  alt={`Cover design ${src.split("/").pop()}`}
                  className="slide-image"
                />
              </div>
            ))}
          </Slider>
        </div>

        {/* Right: Benefits */}
        <div className="student-info">
          <Heading
            subtitle="LEARN ANYTHING"
            title="Benefits About Online Learning Expertise"
          />
          {Array.isArray(homeAbout1) && homeAbout1.length > 0 ? (
            <ul className="benefit-list" aria-label="Benefits about online learning">
              {homeAbout1.map((val) => (
                <li className="benefit-item" key={val.id}>
                  <div className="benefit-icon">
                    <img src={val.cover} alt={val.title} loading="lazy" decoding="async" />
                  </div>
                  <div className="benefit-text">
                    <h3>{val.title}</h3>
                    <p>{val.desc}</p>
                  </div>
                </li>
              ))}
            </ul>
          ) : (
            <p className="benefit-empty" role="status">No benefits available at the moment.</p>
          )}
        </div>
      </div>
    </section>
  );
};

export default Student;
